import { gql } from '@apollo/client/core';

export const DATA = gql`
  query data {
    data {
      specialty {
        key
        value
        group
      }
    }
  }
`;

export const FEATURE_FLAGS = gql`
  query featureFlags {
    featureFlags {
      name
      enabled
    }
  }
`;
